import { configureStore, combineReducers } from '@reduxjs/toolkit';
import customiseCombinedReducer from '../../customise/store';

export const storeFactory = () =>
  configureStore({
    reducer: combineReducers({
      customiseCombinedReducer,
    }),
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        // Note: Both of these options are meant to be enabled in dev mode.
        // We are storing errors in the state which are not serializable.
        // Also this is as well slowing down development.
        serializableCheck: false,
        // This is slowing down development since we have large state
        // values. @see https://github.com/reduxjs/redux-toolkit/issues/415
        immutableCheck: false,
      }),
  });

const store = storeFactory();

export type IStore = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
